'use client';

import { usePathname } from 'next/navigation';
import { useState } from 'react';
import { CaretDown } from '@phosphor-icons/react';
import Cookies from 'js-cookie';
import RegionSelectModal from '../layout/footer/regionSelectModal';

export const options = [
  {
    code: 'au',
    label: 'English/Australia',
    locale: 'en-AU',
    country: 'Australia',
    currency: '$AUD',
    flag: '/assets/footer/flags/Australia.svg',
  },
  {
    code: 'nz',
    label: 'English/New Zealand',
    locale: 'en-NZ',
    country: 'New Zealand',
    currency: '$NZD',
    flag: '/assets/footer/flags/NewZealand.svg',
  },
  {
    code: 'us',
    label: 'English/US',
    locale: 'en-US',
    country: 'United States',
    currency: '$USD',
    flag: '/assets/footer/flags/USA.svg',
  },
  {
    code: 'in',
    label: 'English/India',
    locale: 'en-IN',
    country: 'India',
    currency: '₹INR',
    flag: '/assets/footer/flags/India.svg',
  },
];

export function LanguageSwitcher() {
  const pathname = usePathname();
  const [openRegionSelector, setOpenRegionSelector] = useState(false);

  const segments = pathname.split('/').filter(Boolean);
  const currentCode = segments[0] || 'au';
  const currentLabel =
    options.find((opt) => opt.code === currentCode)?.label || options[0].label;

  function handleChange(nextCode: string) {
    if (!pathname) return;

    const nextOption = options.find((opt) => opt.code === nextCode);
    if (!nextOption) return;

    Cookies.set('language', nextCode, { expires: 365 });
    Cookies.set('locale', nextOption.locale, { expires: 365 });

    const SINGLE_REGION_DOMAIN =
      process.env.NEXT_PUBLIC_SINGLE_REGION_URL || 'https://unimig.com.au';
    const MULTI_REGION_DOMAIN =
      process.env.NEXT_PUBLIC_WEBSITE_URL || 'https://unimig.com';

    let targetUrl = '';

    if (nextCode === process.env.NEXT_PUBLIC_SITE_REGION) {
      // Single-region domain
      targetUrl = SINGLE_REGION_DOMAIN;
    } else {
      // Multi-region domain
      targetUrl = `${MULTI_REGION_DOMAIN}/${nextCode}`;
    }

    window.location.href = targetUrl;
  }

  function handleOpenRegionSelector() {
    setOpenRegionSelector(true);
  }

  return (
    <div>
      <button
        onClick={handleOpenRegionSelector}
        className="font-proxima_font px-1 whitespace-nowrap flex items-center gap-2"
      >
        <span>{currentLabel}</span>
        <CaretDown weight="bold" className="pointer-events-none" size={16} />
      </button>
      <RegionSelectModal
        open={openRegionSelector}
        onOpenChange={(state) => {
          setOpenRegionSelector(state);
        }}
        options={options}
        onSelect={handleChange}
      />
    </div>
  );
}
